module.exports = __webpack_public_path__ + "static/media/2_The inner voice_UAE.9917302b.txt";